import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', () => {
  const { $axios } = useNuxtApp()
  const user = ref<any>(null)

  function setUser(newUser: any) {
    user.value = newUser
    if (newUser) {
      useSetSafeStorage('user', JSON.stringify(newUser))
    } else {
      useRemoveSafeStorage('user')
    }
  }

  async function updateUser(updatedFields: any) {
    const restaurantStore = useRestaurantStore()
    const updatedUser = { 
      ...user.value, 
      ...updatedFields,
      slug: restaurantStore.slug || useSafeStorage('_slug')
    }

    try {
        await $axios.put('/customer-app/update-user-preferences', updatedUser)
        setUser(updatedUser)
    } catch (err) {
        console.error('Failed to update user preferences:', err)
    }
  }

  function getDataFromStorage() {
    if (process.client) {
      user.value = JSON.parse(useSafeStorage('user') || 'null')
    }
  }

  getDataFromStorage()

  return {
    user,

    setUser,
    updateUser,
    getDataFromStorage,
  }
})
